import { Link } from "react-router-dom";
import { Input, InputGroup } from "reactstrap";
import { Btn, H6, Image, LI, UL } from "../../../../AbstractElements";
import { Checkout, Href } from "../../../../Utils/Constants";
import { cartsData } from "../../../../Data/Layout/Header";
import { dynamicImage } from "../../../../Utils";
import FeatherIcons from "../../../../Utils/CommonComponents/CommonIcons/FeatherIcons";

const CartBox = () => {
  return (
    <UL>
      {cartsData.map((data, index) => (
        <LI key={index}>
          <div className="d-flex">
            <Image className="img-fluid b-r-5 me-3 img-60" src={dynamicImage(`other-images/${data.img}`)} alt="cart" />
            <div className="flex-grow-1">
              <span className="f-w-600">{data.userName}</span>
              <div className="qty-box">
                <InputGroup>
                  <span className="input-group-prepend">
                    <Btn className="quantity-left-minus"> -</Btn>
                  </span>
                  <Input className="input-number" type="text" name="quantity" defaultValue={1} />
                  <span className="input-group-prepend">
                    <Btn className="quantity-right-plus">+ </Btn>
                  </span>
                </InputGroup>
              </div>
              <H6 className="font-primary">${data.amount}</H6>
            </div>
            <div className="close-circle">
              <Link className="bg-danger" to={Href}>
                <FeatherIcons iconName="X" />
              </Link>
            </div>
          </div>
        </LI>
      ))}
      <LI className="total">
        <H6 className="mb-0">
          Order Total : <span className="f-w-600 f-right">$1000.00</span>
        </H6>
      </LI>
      <LI className="text-center">
        <Link className="d-block mb-3 view-cart f-w-700" to={`${process.env.PUBLIC_URL}/ecommerce/cart`}>
          {"Go to your cart"}
        </Link>
        <Link className="btn btn-primary view-checkout" to={`${process.env.PUBLIC_URL}/ecommerce/checkout`}>
          {Checkout}
        </Link>
      </LI>
    </UL>
  );
};

export default CartBox;
